import Const from 'constants';
import Action from 'actions';

let FilterByTiers = {
    setUnusedTierNumber(tierNumber, isUnused) {
        return {
            type: Const.FILTER_BY_TIERS_SET_UNUSED_TIER_NUMBER,
            tierNumber,
            isUnused,
        };
    },
    setPlayerTiersFilter(tier) {
        return {
            type: Const.SET_PLAYER_TIERS_FILTER,
            tier,
        };
    },
};

export default Object.assign(Action, FilterByTiers);
